import i18n from '@/libs/i18n'
import store from '@/store'
import useEntityCrud from '@/composable/useEntityCrud'
import useEntityHelper from '@/composable/useEntityHelper'
import useErrorManager from '@/composable/useErrorManager'
import { ref } from '@vue/composition-api'

export default function useServicesList() {
  const MODULE_NAME = 'services'
  const ENDPOINT = 'services'

  const { getAlt, createTagIdArray } = useEntityHelper()
  function convertResource(resource, selectedLang) {
    return {
      ...resource,
      title: resource.title[selectedLang],
      keywords: resource.keywords[selectedLang],
      content: resource.content[selectedLang],
      description: resource.description[selectedLang],
      lang: selectedLang,
      category: resource.serviceCategoryId ? { title: resource.serviceCategoryId.title[selectedLang], _id: resource.serviceCategoryId._id } : {},
      tags: resource.tagIds && resource.tagIds.length ? resource.tagIds.filter(itemEntry => itemEntry && itemEntry.language === selectedLang) : null,
      user: resource.userId,
      editor: resource.editorId ? { fullName: resource.editorId.fullName, _id: resource.editorId._id } : {},
      writer: resource.writerId,
      serviceThumbnail: resource.serviceThumbnailFileId ? resource.serviceThumbnailFileId[selectedLang] : '',
      serviceThumbnailAlt: getAlt('serviceThumbnailFileId', resource, selectedLang),
      serviceCoverImage: resource.serviceCoverImageFileId ? resource.serviceCoverImageFileId[selectedLang] : '',
      serviceCoverImageAlt: getAlt('serviceCoverImageFileId', resource, selectedLang),
      serviceLink: { name: `pages-${MODULE_NAME}-edit`, params: { id: resource._id, lang: selectedLang } },
    }
  }
  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)
  const { itemLoading, item, form } = entity

  const serviceCategories = ref([])
  const isUniqueSlug = ref(true)
  const errorManager = useErrorManager()

  const tableColumns = [
    {
      key: 'title',
      label: i18n.t('general.title'),
      type: 'textImage',
      textKey: 'title',
      imageKey: 'serviceThumbnail',
      linkKey: 'serviceLink',
    },
    { key: 'user', label: i18n.t('general.creator'), type: 'user' },
    {
      key: 'serviceCoverImageFileId',
      label: i18n.t('general.cover'),
      type: 'image',
      sortable: false,
      icon: 'ImageIcon',
    },
    { key: 'sort', label: i18n.t('general.priority'), sortable: true },
    { key: 'category', label: i18n.t('general.category'), sortable: false },
    {
      key: 'tags',
      label: i18n.t('general.tags'),
      sortable: false,
      type: 'pills',
    },
    {
      key: 'createdAt',
      label: i18n.t('general.createdAt'),
      type: 'dateTime',
      sortable: true,
    },
    {
      key: 'updatedAt',
      label: i18n.t('general.updatedAt'),
      type: 'dateTime',
      sortable: true,
    },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },
  ]

  const fetchServiceCategories = (lang = 'fa', search = '') => {
    entity.itemLoading.value = true
    store
      .dispatch('crud/fetchList', {
        queryParams: { lang, search },
        endpoint: 'services-categories',
      })
      .then(response => {
        serviceCategories.value = response.data.data.map(itemEntry2 => ({ _id: itemEntry2._id, title: itemEntry2.title[lang] }))
      })
      .catch(err => {
        useErrorManager(err)
      })
      .finally(() => {
        const assignmentResult = false
        entity.itemLoading.value = assignmentResult; return assignmentResult
      })
  }

  const checkSlugIsUnique = (lang = 'fa', slug) => {
    if (slug === '' || (item.value && item.value.slug === form.value.slug)) {
      isUniqueSlug.value = true
      return
    }
    itemLoading.value = true
    store
      .dispatch('crud/fetchItem',
        { data: { id: slug }, queryParams: { lang }, endpoint: 'services/slug' })
      .then(response => {
        isUniqueSlug.value = response.data.isUnique
      })
      .catch(err => {
        errorManager(err)
      })
      .finally(() => {
        const assignmentResult = false
        itemLoading.value = assignmentResult; return assignmentResult
      })
  }

  return {
    ...entity,
    checkSlugIsUnique,
    convertResource,
    createTagIdArray,
    errorManager,
    fetchServiceCategories,
    isUniqueSlug,
    serviceCategories,
    tableColumns,
  }
}
